<template lang="html">
  <div class="columns container-pannel"
       v-if="review != null">
    <div class="column middle-panel"
         :style="get_middle_pannel_style()"
         style="padding-bottom: 0px;"
         :class="{'show-pad': showPad}">

      <ReviewDetail ref="reviewDetail"
                    :review="review"
                    :showPad="showPad">
      </ReviewDetail>
      <br/>
      <div class="timeline"
           :style="timelineStyle">
        <ReviewState v-for="state in review.state_set"
                     :context="state"
                     :review="review"
                     :key="state.uid"
                     :can_delete="review.state_set.indexOf(state) == 0"
                     v-on:FlowDetail:delete_state="delete_state()"/>
      </div>
    </div>


    <div class="column right-panel"
         style="margin-top: 1em;"
         :style="{'width': 'calc(100vw - ' + 2*middleColWidth + 'px )'}"
         :class="{'show-pad':showPad}">
      <div class="d-flex d-flex mb-3 mt-1 align-items-center">
        <div class="col-auto me-3">
          <img :src="logo"
               class="card-img rounded-xl sh-4 sw-4"
               alt="thumb">
        </div>
        <div class="cta-3 text-primary establishment-title">
          {{ review.establishment.name }}
        </div>
        <a :href="review.establishment.website"
           target="_blank"
           title="Site officiel"
           class="me-2 ms-auto">
          <i class="icon-18 bi-globe"></i>
        </a>
        <a v-if="review.establishment.page_reseau_public"
           :href="review.establishment.page_reseau_public"
           target="_blank"
           title="Lien reseaux social"
           class="me-2">
          <i class="icon-18 bi-facebook"></i>
        </a>
        <a v-if="review.establishment.page_reseau_public_2"
           :href="review.establishment.page_reseau_public_2"
           target="_blank"
           title="Lien reseaux social"
           class="me-2">
          <i class="icon-18 bi-instagram"></i>
        </a>
      </div>

      <EstablishmentInfo :review="review" v-if="showPad" :selectPage="selectPadPage"/>

    </div>
  </div>
</template>

<script>
import ReviewState from '@/components/ReviewState.vue';
import ReviewDetail from '@/components/ReviewDetail.vue';
import EstablishmentInfo from '@/components/EstablishmentInfo.vue';
import settings from "@/settings.coffee";
import REVIEW_DETAIL from '@/gql/queries/reviewDetail.graphql';
import REVIEW_STATE_BACK from '@/gql/mutations/reviewStateBack.graphql';
import { gqlQuery, gqlMutation } from '@/gqlClient.js';
import utils from '@/utils.js';

export default {
  name: "FlowDetail",
  components: {
    ReviewState,
    ReviewDetail,
    EstablishmentInfo
  },
  props: {
    uid: {
      required: false,
      type: String
    },
    showPad: {
      type: Boolean,
      default: true
    },
    selectPadPage: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      review: null,
      timelineHeight: "500px",
      middleColWidth: window.innerWidth * 1.1 / 3
    };
  },
  computed: {
    review_uid() {
      return this.$store.state.selected_review_uid;
    },
    timelineStyle() {
      return { height: this.timelineHeight };
    },
    logo() {
      return settings.backendMediaUrl + this.review.establishment.logo;
    }
  },
  methods: {
    get_middle_pannel_style() {
      if (this.showPad) {
        return {
          width: this.middleColWidth + 'px',
          minWidth: this.middleColWidth + 'px'
        };
      }
      return {};
    },
    delete_state() {
      const self = this;
      gqlMutation(REVIEW_STATE_BACK, { uid: self.review.uid }).then((resp) => {
        if (!resp.body.data.review_state_back.ok) {
          console.error("error", resp.body.data);
        }
      });
    },
    async fetch_data() {
      const self = this;
      if (self.review_uid) {
        const response = await gqlQuery(REVIEW_DETAIL, { uid: self.review_uid });
        if (response.ok) {
          self.review = response.body.data.review;
        }
        setTimeout(() => {
          self.setHeight();
        }, 1);
      }
    },
    setHeight: utils.debounce(function () {
      if (this.$refs.reviewDetail) {
        this.timelineHeight = (window.innerHeight - this.$refs.reviewDetail.$el.clientHeight - 100) + "px";
      }
      this.middleColWidth = window.innerWidth * 1.1 / 3;
    }, 500)
  },
  watch: {
    review_uid(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.fetch_data();
      }
    }
  },
  mounted() {
    const self = this;

    self.fetch_data();

    self.$djangows['onmodelsignals'](
        { modelName: "state", appLabel: "state" },
        (event) => {
          if (event.obj && event.obj.review === self.review_uid) {
            self.fetch_data();
          }
        }
    );

    self.$djangows['onmodelsignals'](
        { modelName: "review", appLabel: "review" },
        (event) => {
          if (event.obj.uid === self.review_uid) {
            self.fetch_data();
          }
        }
    );

    self.setHeight();
    window.addEventListener('resize', self.setHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight);
  }
};
</script>


<style lang="scss" scoped>
.full-width {
  background-color: red;
  width: 100%;
}

.timeline {
  padding-right: 10px;
  overflow: scroll;
}

.establishment-title {
  white-space: nowrap;

  text-overflow: ellipsis;
  overflow: hidden;
}

.container-pannel {
  overflow: hidden;
  max-height: calc(100vh - 90px);
  padding-left: 0px;
}

.middle-panel {
  flex-grow: unset;
  flex-basis: auto;
  transition: width 0.3s ease-in-out;
  min-width: 895px;
  width: calc(100vw - 550px);
}

.middle-panel.show-pad {
  /*width: 540px;
  min-width: 540px;*/
}

.right-panel {
  right: 0;
  border: 0px solid red;
  overflow: hidden;
  opacity: 0;
  display: none;
}

.right-panel.show-pad {
  visibility: visible;
  display: block;
  opacity: 1;

}
</style>
